import { useState } from "react";
import "./Calendario.scss";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";

export default function Calendario(props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className={`calendario`}>
        <i
          style={{ cursor: "pointer" }}
          onClick={() => {
            setOpen(!open);
          }}
          className="fa-solid fa-calendar"
        ></i>
        {props.selectedDate && (
          <div className="selecionado">
            {Array.isArray(props.selectedDate) ? (
              <p>
                {new Date(props.selectedDate[0]).toLocaleDateString()} -{" "}
                {props.selectedDate[1]
                  ? new Date(props.selectedDate[1]).toLocaleDateString()
                  : "?"}
              </p>
            ) : (
              <p>{new Date(props.selectedDate).toLocaleDateString()}</p>
            )}
            <ButtonIcon
              Excluir
              onExcluir={() => {
                props.setSelectedDate(null);
              }}
            />
          </div>
        )}
        {open && (
          <Calendar
            onChange={(value) => {
              props.setSelectedDate(value);
              if (props.selectRange) {
                if (
                  !Array.isArray(value) ||
                  (value[1] !== null && value[1] !== undefined)
                ) {
                  setOpen(false);
                }
              } else {
                setOpen(false);
              }
            }}
            value={
              props.selectedDate === null
                ? props.selectRange
                  ? null // não pré-seleciona nada no modo intervalo
                  : new Date()
                : Array.isArray(props.selectedDate)
                ? [
                    new Date(props.selectedDate[0]),
                    props.selectedDate[1]
                      ? new Date(props.selectedDate[1])
                      : null,
                  ]
                : new Date(props.selectedDate)
            }
            selectRange={props.selectRange}
          />
        )}
      </div>
    </>
  );
}

Calendario.defaultProps = {
  id: "",
  className: "",
  setSelectedDate: () => null,
  selectedDate: null,
  selectRange: false,
};
